
import { ButtonActions } from './button-actions';

export class ButtonActionsSerializer {

  fromJson(json: any): ButtonActions {
    const ba = new ButtonActions();
    if (typeof json.success !== 'undefined') {
        ba.success = json.success;
        ba.data = this.toJson(json.data);
        return ba;
    } else {
        return this.toJson(json);
    }
  }

  toJson(ba: ButtonActions): any {
    if (typeof ba === 'object') {
      return {
        uri: ba.uri,
        step_id: ba.step_id,
        feedBack_id: ba.feedBack_id,
        stage_id: ba.stage_id,
        person_id: ba.person_id,
        applyment_id: ba.applyment_id,
        button_id: ba.button_id,
        data: ba.data,
        link: ba.link,
        new_tab: ba.new_tab,
        place_id: ba.place_id,
        place_type_id: ba.place_type_id,
        token: ba.token,
        selective_process_id: ba.selective_process_id,
        close_popup: ba.close_popup,
        last_place_id: ba.last_place_id,
        last_place_type_id: ba.last_place_type_id
      };
    } else {
      return ba;
    }
  }
}
